import { render, staticRenderFns } from "./0006.vue?vue&type=template&id=ffd01f0a&scoped=true&"
import script from "./0006.vue?vue&type=script&lang=js&"
export * from "./0006.vue?vue&type=script&lang=js&"
import style0 from "./0006.vue?vue&type=style&index=0&id=ffd01f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd01f0a",
  null
  
)

export default component.exports